import { node } from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { styleOverrideReason } from '@ids/core';
import { getStyle as get } from '@ids/ddms-styled/comps/cardStandard/intuit/light/index';

const Wrapper = styled.div`
  padding: ${get('background.spacing')};
  flex: 1;
`;

/**
 *
 */
const CardContent = props => {
  const { children, ...restProps } = props;

  return <Wrapper {...restProps}>{children}</Wrapper>;
};

CardContent.propTypes = {
  /**
   * Inner content of card content
   */
  children: node,
  /**
   * When `style` or `className` prop is provided, provide the reason behind the override.
   */
  styleOverrideReason
};

CardContent.defaultProps = {
  children: null,
  styleOverrideReason: undefined
};

export default CardContent;
